import React, { useCallback, useEffect, useMemo, useState } from "react";
import style from "./index.module.scss";
import UploadImage from "../UploadImage";
import { Button, Col, Icon, Progress, Row } from "antd";
import useRequest, { errorMessage } from "Utils/useRequest";
import { uploadToQiNiu } from "API";
import { ResultMessage } from "components/ResultMessage";
import Viewer from "react-viewer";
import {
    savePhoneFile,
    getStudentPhoneFileList,
    deletePhoneFile
} from "../../../../../../../API";
import { nanoid } from "nanoid";

interface ExamUploadModalProps {
    isAfter: boolean; //当前考核是否已结束
    handleFilesNum: (val: number) => void;
    examId: string; //考试id
}

const Index = ({ isAfter, examId, handleFilesNum }: ExamUploadModalProps) => {
    const [visible, setVisible] = useState(false);
    const [activeIndex, setActiveIndex] = useState<number>(0);

    //上传中的图片
    const [uploadingFiles, setUploadingFiles] = useState<{
        [key: string]: number;
    }>({});

    //上传成功的图片
    const [fileList, setFileList] = useState<string[]>([]);

    const [fileListData] = useRequest(
        () => getStudentPhoneFileList(examId, "mobile"),
        {},
        [examId]
    );

    useEffect(() => {
        if (!fileListData) return;
        setFileList(fileListData.fileList);
    }, [fileListData]);

    //更新附件数
    useEffect(() => {
        handleFilesNum(fileList.length);
    }, [fileList]);

    //预览图片
    const viewerSrc = useMemo(() => {
        return fileList.map(item => ({ src: item, alt: "" }));
    }, [fileList]);

    //获取上传进度
    function onUploadProgress(file: any, percent: number) {
        let uid = file.uid;

        setUploadingFiles((percentFile: { [key: string]: number }) => ({
            ...percentFile,
            [uid]: percent
        }));
    }

    //上传附件
    async function onUpload(e: any) {
        try {
            //获取上传后七牛地址
            const data = await uploadToQiNiu(e.file, { onUploadProgress });
            const url = `${data.url}&key=${nanoid()}`;
            await savePhoneFile(examId, url, "mobile");
            setFileList(fileList => [...fileList, url]);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    //删除附件
    const deletePics = async (fileUrl: string) => {
        try {
            await deletePhoneFile(examId, fileUrl, "mobile");
            await setFileList(fileList =>
                fileList.filter(item => item !== fileUrl)
            );
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    };

    const handleClick = useCallback((index: number) => {
        setVisible(true);
        setActiveIndex(index);
    }, []);

    return (
        <div className={style.root}>
            <Row gutter={[24, 20]}>
                {!isAfter && (
                    <Col span={6}>
                        <UploadImage onUpload={onUpload}>
                            <Button
                                type="default"
                                className={style.btn}
                                title="上传图片">
                                <Icon type="plus" />
                            </Button>
                        </UploadImage>
                    </Col>
                )}

                {fileList.map((item, index) => (
                    <Col
                        span={6}
                        key={index + Math.random()}
                        className={style.item}>
                        {!isAfter && (
                            <Icon
                                type="close-circle"
                                theme="filled"
                                className={style.close}
                                onClick={() => deletePics(item)}
                            />
                        )}
                        <img src={item} onClick={() => handleClick(index)} />
                    </Col>
                ))}

                {Object.keys(uploadingFiles)
                    .filter(key => uploadingFiles[key] !== 100)
                    .map(item => (
                        <Col span={6} className={style.loading} key={item}>
                            <img src={require("./img/img.svg")} alt="" />
                            <Progress
                                percent={uploadingFiles[item]}
                                size="small"
                                status="active"
                                showInfo={false}
                            />
                        </Col>
                    ))}
            </Row>

            <Viewer
                visible={visible}
                activeIndex={activeIndex}
                onClose={() => setVisible(false)}
                images={viewerSrc}
            />
        </div>
    );
};

export default Index;
